export default {"src":"/_next/static/media/kiribati.1ea25232.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};